module.exports = __webpack_public_path__ + "img/header-weddingRingsFinishes.33e2a22.jpg";